import { memo } from 'react';
import Image from 'next/image';
import { Link } from '@appsumo/dorado-react';

import { SOCIAL_LINKS_CONFIG } from '~/constants/product';
import type { FTFLink, FTFSocialLinkType } from '~/types/product';

export default memo(function FTFSocialLinks({
  links,
}: Readonly<{ links: FTFLink[] }>) {
  if (!links?.length) return null;

  return (
    <ul className="mt-2 flex flex-row gap-4" data-testid="ftf-social-links">
      {links.map((link) => (
        <li key={link.id}>
          <Link href={link.url} target="_blank" title={link.title}>
            <Image
              src={SOCIAL_LINKS_CONFIG[link.type as FTFSocialLinkType].icon}
              alt={link.title}
              width={20}
              height={20}
            />
          </Link>
        </li>
      ))}
    </ul>
  );
});
